import { Component, OnInit } from '@angular/core';
import * as AOS from 'aos';
import { BlogService } from 'src/app/Services/Blog/blog.service';
//import { EventService } from 'src/app/Services/Event/event.service';
import { faThumbsUp, faThumbsDown, faTrash, faComment } from '@fortawesome/free-solid-svg-icons';
import { UserService } from 'src/app/Services/User/user.service';
import * as script from 'src/assets/scripts/script.js';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss',]
})
export class HomeComponent implements OnInit {

  ListBlog: any;
  ListEvent: any;
  faThumbsUp = faThumbsUp;
  faThumbsDown = faThumbsDown;
  faTrash = faTrash;
  faComment = faComment;
  nBlogs: any;
  nEvents: any;
  listClub :any ;  
  nclubs :  any ; 
  isFlipped = false;


  

  flipCard() {
    this.isFlipped = !this.isFlipped;
  }

  constructor(private blogservice: BlogService,
              private userservice:UserService) { }

  ngOnInit(): void {
    AOS.init();
    this.getAllBlogs();
   
    
  }

  

  getAllBlogs() {
    this.blogservice.getAllBlog().subscribe(
      data => {
        this.ListBlog = data;
        this.nBlogs = this.ListBlog.length;
        return this.ListBlog;
      }
    )
  }
 

  setIdUser(id: any) {
    localStorage.setItem("IdUser", id);
  }

  setBlogId(id: any) {
    sessionStorage.setItem("IdBlog", id);
  }

  setEventId(id: any) {
    sessionStorage.setItem("IdEvent", id);
  }

  likeBlog(id: any) {
    this.blogservice.likeBlog(id).subscribe(
      data => {
        let hidelike = true;
        let hidedislike = false;
        return data;
      }
    )
  }

  dislikeBlog(id: any) {
    this.blogservice.disLikeBlog(id).subscribe(
      data => {
        let hidelike = false;
        let hidedislike = true;
        return data;
      }
    )
  }

getAllClubs() {
  this.userservice.getAllClubScore().subscribe(
    (data) => {
      this.listClub = data;
      this.nclubs = this.listClub.length;
      console.log(data);
      return this.listClub;
    },
    (err) => {
      console.log(err);
    }
  );
}






}